import React from "react";
import { List } from "@raketa-cms/raketa-cms";
import { ImagePicker } from "@raketa-cms/raketa-image-picker";

const ImagesInput = ({ label, value, onChange }) => (
  <List
    label={label}
    listItem={(settings, onChangeItem) => (
      <ImagePicker
        label="Image"
        value={settings.image}
        onChange={(value) => onChangeItem("image", value)}
      />
    )}
    items={value.map((item, idx) => {
      return {
        id: item.id || idx,
        image: item,
      };
    })}
    template={{ image: "" }}
    primaryField="image.name"
    onChangeList={(_list, newList) =>
      onChange(newList.map((item) => item.image))
    }
  />
);

export default ImagesInput;
